import { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import { Feature } from '@tencent/workbench';
import { FontStyleName } from './config';
import { getTitleStyle, updateTitleStyle } from '@framework/workbench/drawer/ui/chart/common/font/util/title';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IChartTextProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/chart-shape-property.interface';
import ChartBaseDrawerFeature from '@src/framework/workbench/drawer/ui/chart/chart-base-drawer-feature';
import { ChartElementType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-interaction.interface';
import { ChartActionType } from '@src/slide/domain/ui-model/element-modeles/property/chart/constant';
@Feature()
export class ChartFontStyleFeature extends ChartBaseDrawerFeature {
    /**
     * 判断图表字体的 font style 的各个样式（bold、italic、 ...），是否应该为 已选中 或 未选中 状态
     * @param style font style 的各个样式的 key
     */
    // eslint-disable-next-line complexity
    public shouldFontStyleBtnCheck(style: string) {
        if (!this.isValidFontStyle(style)) return;
        const model = this.getSelectModel() as IChartModel;
        if (!model || model.type !== UIModelType.CHART || !model.selectedElement) return;
        const selecetdElementType = model.selectedElement.type;
        const element = model.getSelectedElementProperty() as IChartTextProperty;
        if (!element) return '';
        if (style === FontStyleName.Bold) {
            if (selecetdElementType === ChartElementType.TITLE) {
                return this.getTitleTextFontBold(model);
            }
            return element.getTextFontBold() || false;
        } if (style === FontStyleName.Italic) {
            if (selecetdElementType === ChartElementType.TITLE) {
                return this.getTitleTextFontItalic(model);
            }
            return element.getTextFontItalic() || false;
        }
    }
    /**
     * 设置图表字体的font-weight:bold
     * 更新本地图表数据中，需要更新 font style 属性的字段值
     */
    public setFontBold(value: boolean): void {
        const model = this.getSelectModel() as IChartModel;
        if (!model || model.type !== UIModelType.CHART || !model.selectedElement) return;
        const selecetdElementType = model.selectedElement.type;
        if (selecetdElementType === ChartElementType.TITLE) {
            return this.updateTitleFontStyle(model, ChartActionType.BOLD, value);
        }
        const element = model.getSelectedElementProperty() as IChartTextProperty;
        return element.updateFontStyle(ChartActionType.BOLD, value);
    }

    /**
     * 设置图表的 font-style:italic
     * 更新本地图表数据中，需要更新 font style 属性的字段值
     */
    public setFontItalic(value: boolean): void {
        const model = this.getSelectModel() as IChartModel;
        if (!model || model.type !== UIModelType.CHART || !model.selectedElement) return;
        const selecetdElementType = model.selectedElement.type;
        if (selecetdElementType === ChartElementType.TITLE) {
            return this.updateTitleFontStyle(model, ChartActionType.ITALIC, value);
        }
        const element = model.getSelectedElementProperty() as IChartTextProperty;
        return element.updateFontStyle(ChartActionType.ITALIC, value);
    }

    /**
     * 判断参数值是否为合法的 font style 值
     * @param style font style 的各个样式的 key
     */
    private isValidFontStyle(style: string) {
        const availableFontStyles = Object.values(FontStyleName);
        return availableFontStyles.includes(style);
    }

    private getTitleTextFontBold(model: IChartModel): boolean {
        return getTitleStyle(model, ChartActionType.BOLD);
    }

    private getTitleTextFontItalic(model: IChartModel): boolean {
        return getTitleStyle(model, ChartActionType.ITALIC);
    }

    private updateTitleFontStyle(model: IChartModel, actionType, value) {
        updateTitleStyle(model, actionType, value);
    }
}
